
const routes = [
  {
    path: '/',
    component: () => import('layouts/main-layout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('pages/index.vue')
      }
    ]
  },
  {
    path: '/configurador/:brand',
    component: () => import('layouts/configurator-layout.vue'),
    children: [
      {
        path: '',
        name: 'configurator',
        component: () => import('pages/configurator/index.vue')
      }
    ]
  },
  {
    path: '/configurador/:brand/mi-carrito',
    component: () => import('layouts/configurator-layout.vue'),
    children: [
      {
        path: '',
        name: 'cart',
        component: () => import('pages/configurator/configurator-cart.vue')
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/error404.vue')
  }
]

export default routes
